import React from 'react';
import styled from 'styled-components';
import TopNavigation from '@/components/organisms/TopHavigation/TopHavigation';

const Inner = styled.div`
	position: relative;
`

interface BasicContainerProps {
	children: React.ReactNode;
}


const BasicContainer: React.FC<BasicContainerProps> = ({ children }) => {
	return (
		<Inner>
			{/*<TopNavigation />*/}
			{children}
		</Inner>
	)
}

export default BasicContainer